module.exports = __webpack_public_path__ + "static/img/customer.2843bff0.png";